import {
  InlineAlert,
  Page,
  PageContent,
  PageDescription,
  PageHeader,
  PageTitle,
  PageTitleBlock,
} from '@planuze/ui';
import { ReservedUsernamesCard } from '../components/accounts/reserved-usernames-card.js';
import { PublicEmailDomainsCard } from '../components/publishers/public-email-domains-card.js';
import { ReservedSlugsCard } from '../components/publishers/reserved-slugs-card.js';
import { usePlatformSettingsContent } from '../content/sections/platform-settings.js';
import { useStaffSession } from '../hooks/use-staff-session.js';

/* Configurações de plataforma (ADR-0704): reúne a curadoria de namespace/onboarding que antes
   vivia grudada nas listas de Empresas (domínios públicos) e Publishers (slugs reservados). São
   config globais de super_admin — não pertencem ao browse de entidades. Tela dedicada. */
export function PlatformSettingsPage() {
  const copy = usePlatformSettingsContent();
  const session = useStaffSession();
  const isSuperAdmin = session?.role === 'super_admin';

  return (
    <Page>
      <PageHeader>
        <PageTitleBlock>
          <PageTitle>{copy.pageTitle}</PageTitle>
          <PageDescription>{copy.pageDescription}</PageDescription>
        </PageTitleBlock>
      </PageHeader>
      <PageContent className="space-y-8">
        {isSuperAdmin ? (
          <>
            <section className="space-y-2">
              <h2 className="text-sm font-semibold text-foreground">{copy.emailDomainsTitle}</h2>
              <p className="max-w-2xl text-sm text-muted-foreground">
                {copy.emailDomainsDescription}
              </p>
              <PublicEmailDomainsCard />
            </section>
            <section className="space-y-2 border-t border-border pt-6">
              <h2 className="text-sm font-semibold text-foreground">{copy.reservedSlugsTitle}</h2>
              <p className="max-w-2xl text-sm text-muted-foreground">
                {copy.reservedSlugsDescription}
              </p>
              <ReservedSlugsCard />
            </section>
            <section className="space-y-2 border-t border-border pt-6">
              <h2 className="text-sm font-semibold text-foreground">
                {copy.reservedUsernamesTitle}
              </h2>
              <p className="max-w-2xl text-sm text-muted-foreground">
                {copy.reservedUsernamesDescription}
              </p>
              <ReservedUsernamesCard />
            </section>
          </>
        ) : (
          <InlineAlert variant="info">{copy.forbiddenMessage}</InlineAlert>
        )}
      </PageContent>
    </Page>
  );
}
